import axios, { type AxiosInstance } from 'axios';
import { API_BASE_URL, API_TIMEOUT } from './config';
import { createRequestInterceptor, createResponseInterceptor } from './interceptors';

// Extend AxiosRequestConfig to include metadata for retries
declare module 'axios' {
  interface InternalAxiosRequestConfig {
    metadata?: {
      retryCount?: number;
    };
    _retry?: boolean;
  }
}

// Create axios instance with base configuration
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Apply enhanced interceptors
const requestInterceptor = createRequestInterceptor();
const responseInterceptor = createResponseInterceptor();

apiClient.interceptors.request.use(requestInterceptor.onFulfilled, requestInterceptor.onRejected);

apiClient.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
);

export default apiClient;
